import gql from 'graphql-tag';
import ASSET_FRAGMENT from './Asset';
const I_KEYBOARDING_CURRICULUM_VIDEO_FRAGMENT = gql `
  fragment KeyboardingCurriculumVideoFragment on KeyboardingCurriculumVideo {
    curriculumWeeks {
      week
    }
    id
    name
    description
    videoId
    video {
      ...AssetFragment
    }
  }
  ${ASSET_FRAGMENT}
`;
export default I_KEYBOARDING_CURRICULUM_VIDEO_FRAGMENT;
